export enum OppgaveStatus {
  Ready = 1,
  InProgress = 2,
  Completed = 3,
  Cancelled = 4,
  EnteredInError = 5,
  Expired = 6,
}

export enum OppgaveStatusValue {
  Ready = "ready",
  InProgress = "inprogress",
  Completed = "completed",
  Cancelled = "cancelled",
  EnteredInError = "enteredinerror",
  Expired = "expired",
}
